<template lang="pug">
	modal
		.card.text-left
			.card-header
				span.fa.fa-trash.mr-2
				| Eliminar inserciones
				button.close(@click="cerrar") &times;
			.card-body
				CalendarioAnual(:seleccion.sync="dias", :from="contrato.FechaInicio", :to="contrato.FechaFin", :resaltados="resaltados")
			.card-footer
				button.btn.btn-danger.btn-sm(@click="eliminar")
					span.fa.fa-trash.mr-2
					| Eliminar
				button.btn.btn-warning.btn-sm.ml-2(@click="anular")
					span.fa.fa-ban.mr-2
					| Anular
</template>

<script>
import CalendarioAnual from '../../../../../gestion-emisoras/vue/componentes/utilidades/calendario-anual.vue'
export default {
	props: ['contrato', 'radiacion'],
	components: {
		CalendarioAnual
	},
	data () {
		return {
			dias: []
		}
	},
	computed: {
		resaltados () {
			return this.radiacion.lineas.reduce((acc, linea) => {
				acc = linea.inserciones.reduce((acc, insercion) => {
					if (acc.indexOf(insercion.Dia) < 0 && !insercion.Anulada) {
						acc.push(insercion.Dia)
					}
					return acc
				}, acc)
				return acc
			}, [])
		}
	},
	methods: {
		filtrar () {
			this.dias = this.dias.filter(d => {
				const diaStr = this.$moment(d).format('YYYY-MM-DD')
				return (this.resaltados.indexOf(diaStr) >= 0)
			})
		},
		eliminar () {
			this.filtrar()
			this.$emit('eliminar', this.dias)
			this.cerrar()
		},
		anular () {
			this.filtrar()
			this.$emit('anular', this.dias)
			this.cerrar()
		},
		cerrar () {
			this.$emit('cerrar')
		}
	}
}
</script>




// WEBPACK FOOTER //
// src/modulos/radiacion/vue/components/radiacion/eliminar/eliminar-inserciones.vue